<div class="modal-header" mat-dialog-title>
    <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">science</mat-icon>
    </div>
    <div class="modal-header-titles">
        <h2 class="modal-title">{{ data.titulo }}</h2>
        @if (data.subtitulo) {
        <span class="modal-subtitle">{{ data.subtitulo }}</span>
        }
    </div>
    <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="fechar()">
            <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
    </div>
</div>

<mat-dialog-content class="modal-content">
    <app-alert-card type="info" class="mt-3 d-block">
        Valores estimados com as fórmulas em edição nesta tela, inclusive alterações ainda não salvas.
    </app-alert-card>

    @if (data.formulasCatalogo.length > 0) {
    <mat-expansion-panel class="formulas-panel mt-3">
        <mat-expansion-panel-header>
            <mat-panel-title class="formulas-titulo">
                Fórmulas usadas neste cálculo
            </mat-panel-title>
            <mat-panel-description class="formulas-descricao">
                <span class="status-badge status-qtd" [ngClass]="badgeClasses.quantidade">
                    {{ data.formulasCatalogo.length }} fórmula(s)
                </span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="formulas-lista">
            @for (formula of data.formulasCatalogo; track formula.chaveFormula) {
            <app-formula-card
                [formula]="formula"
                [modo]="modoListagem"
                [estado]="estadoDe(formula.chaveFormula)"
                [mostrarVigencia]="false">
            </app-formula-card>
            }
        </div>
    </mat-expansion-panel>
    }

    <!-- Entradas -->
    @if (entradas.length > 0) {
    <div class="sub-section-container">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">input</mat-icon>
            <span>Entradas</span>
        </div>

        <form [formGroup]="form">
            <div class="row g-3">
                @for (entrada of entradas; track entrada.chaveVariavel) {
                <div class="col-12 col-md-6">
                    @switch (entrada.tipoDadoVariavel) {
                    @case (TipoDadoVariavelEnum.Booleano) {
                    <mat-slide-toggle class="app-toggle-compact entrada-toggle" [formControl]="controle(entrada)">
                        {{ entrada.descricao }}
                    </mat-slide-toggle>
                    }
                    @case (TipoDadoVariavelEnum.Inteiro) {
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>{{ entrada.descricao }}</mat-label>
                        <input matInput type="text" inputmode="numeric" [currencyMask]="integerMask"
                            [formControl]="controle(entrada)">
                    </mat-form-field>
                    }
                    @default {
                    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                        <mat-label>{{ entrada.descricao }}</mat-label>
                        <input matInput type="text" inputmode="numeric" [currencyMask]="decimalMask"
                            [formControl]="controle(entrada)">
                    </mat-form-field>
                    }
                    }
                </div>
                }
            </div>
        </form>
    </div>
    }

    <!-- Saídas -->
    <div class="sub-section-container">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">output</mat-icon>
            <span>Saídas</span>
        </div>

        @if (saidas.length > 0) {
        <div class="sim-breakdown">
            @for (saida of saidas; track saida.chaveFormula) {
            <div class="sim-row">
                <div class="sim-row-label"><span>{{ saida.descricao }}</span></div>
                <div class="sim-row-value">
                    @if (isCalculando) {
                    <app-loading-box height="18" width="90" marginTop="0"></app-loading-box>
                    } @else {
                    {{ saida.valor ?? 0 | number:'1.2-4' }}
                    }
                </div>
            </div>
            }
        </div>
        } @else if (isCalculando) {
        <div class="sim-breakdown">
            @for (linha of [1, 2, 3]; track linha) {
            <div class="sim-row">
                <div class="sim-row-label"><app-loading-box height="18" width="220" marginTop="0"></app-loading-box></div>
                <div class="sim-row-value"><app-loading-box height="18" width="90" marginTop="0"></app-loading-box></div>
            </div>
            }
        </div>
        } @else {
        <app-empty-state
            icon="output"
            title="Nenhum resultado"
            subtitle="Não foi possível simular as fórmulas desta tela.">
        </app-empty-state>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer" align="end">
    <button mat-stroked-button type="button" class="btn-secondary" (click)="fechar()">Fechar</button>
</mat-dialog-actions>
